import React from "react";
import useFlashlight from "../../hooks/useFlashlight";
import { FlashlightWrapper, FlashlightDiv } from "./Flashlight.styles";

const Flashlight = ({ children }) => {
  const { x, y } = useFlashlight();

  return (
    <FlashlightWrapper>
      <FlashlightDiv
        style={{
          "--x": `${x}px`,
          "--y": `${y}px`,
        }}
      />
      {children}
    </FlashlightWrapper>
  );
};

export default Flashlight;
